import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "Check your email", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "govuk-heading-l" }, "Enter your password", -1)
const _hoisted_3 = { class: "govuk-body" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("We have sent an email to ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" with a link to reset your password.")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "govuk-body" }, "After you have reset your password, come back here and continue.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "govuk-body" }, "If you do not get an email, check your spam or try again.", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Sign in ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Heading),
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("strong", null, _toDisplayString(_ctx.loginData.email), 1),
      _hoisted_5
    ]),
    _hoisted_6,
    _hoisted_7,
    _createVNode(_component_router_link, {
      class: "govuk-button",
      to: { name: 'LoginFinish' }
    }, {
      default: _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    })
  ], 64))
}